<template>
  <div
    class="base-three-banner__grid"
  >
    <div v-if="isMobileWidth">
      <div class="base-three-banner__grid__cards">
        <Carousel
          slider-dot-position="center"
          :name="carouselName"
          :size="bigScreen ? threeBanner.length -1 : threeBanner.length"
          :total-all-data="threeBanner.length"
          color-slider="blackWithRoundM"
          :shimmer="false"
          :auto-play="threeBanner.length > 1 ? true : false"
          :auto-play-interval="5000"
          :scroll-focus="false"
          :is-absolute="true"
          :is-banner="true"
          :show-dot="true"
        >
          <template #item>
            <div
              v-for="(slide, index) in threeBanner"
              :id="`${carouselName}-${index+1}`"
              :key="`${index}-key`"
            >
              <component
                :is="'div'"
                :class="`slide-item class-${carouselName}`"
              >
                <img
                  :src="require(`@/assets/new-home/${isMobileWidth ? slide.imgMobile : slide.imgDesktop}`)"
                  :alt="slide.imgDesktop"
                  class="skeleton-box"
                >
                <div class="base-three-banner__grid__cards__content">
                  <h2 v-html="slide.title" />
                  <div class="base-three-banner__grid__cards__content__btn">
                    <Button
                      :id="formatBtnId(slide.textBtn)"
                      :text="slide.textBtn"
                      img="ics_o_arrow_diagonal_black.svg"
                      :round="true"
                      :route-to="{ path: slide.linkBtn }"
                    />
                  </div>
                </div>
              </component>
            </div>
          </template>
        </Carousel>
      </div>
    </div>
    <div
      v-for="(val, index) in threeBanner"
      v-else
      :key="'event-tips-'+ index"
      class="base-three-banner__grid__item"
    >
      <ImageLazy
        :src="require(`@/assets/new-home/${isMobileWidth ? val.imgMobile : val.imgDesktop}`)"
        :alt="val.imgDesktop"
      />
      <div class="base-three-banner__grid__item__child">
        <div> 
          <h1>{{ val.title }}</h1>
          <div class="base-three-banner__grid__item__child__btn">
            <Button
              :id="formatBtnId(val.textBtn)"
              :text="val.textBtn"
              img="ics_o_arrow_diagonal_black.svg"
              :round="true"
              :route-to="{ path: val.linkBtn }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataInfo from "../../app/constants/index";
import ImageLazy from '@/components/ImageLazy/index.vue'
import Button from "@/components/new-button/Button.vue";
import Carousel from "@/components/new-carousel/Carousel";

import {
  generateChunkCarouselResponsive,
  listenerWindowResize,
  MEDIA,
  removeListenerResize
} from "@/components/new-carousel/util.js"

export default {
  name: "SliderSectionHome",
  components: {ImageLazy, Button, Carousel},
  data() {
    return {
      carouselName: 'sliderHome',
      threeBanner: [],
      isMobileWidth: false,
      bigScreen: false,
      DataInfo
    }
  },
  async created() {
    this.isMobile();
    this.threeBanner = this.DataInfo.THREEBANNER
    listenerWindowResize(this.isMobile);
  },
  beforeDestroy() {
    removeListenerResize(this.isMobile)
  },
  methods: {
    isMobile() {
      this.isMobileWidth = generateChunkCarouselResponsive(window.innerWidth) === MEDIA().MOBILE;
    },
    formatBtnId(text) {
      return `btn_${text.replaceAll(' ', '_').toLowerCase()}_new`
    },
  }
}
</script>

<style lang="scss" scoped>
@import "style";
</style>
